import { StructureTool } from './structure_tool';
import { IDs } from '../../IDs';

export function getStaticOption(entity: string, field: string, value: any, module?: string, returnNull?: boolean) {
    const struct = new StructureTool(module || IDs.MOD_ETOOL).getStructure(module || IDs.MOD_ETOOL, entity);
    // console.log('getStaticOption', entity, field, struct);
    if (struct) {
        const att = struct.ATTS.find((a: any) => a.KEY === field);
        if (att && att.OPTS && att.OPTS instanceof Array) {
            const value_found = att.OPTS.find((e: any) => e.VALUE === value);
            if (value_found) {
                return value_found.TITEL || value_found.NAME;
            }
        } else {
            return value;
        }
    }
    if (value === 'euro') {
        return '€';
    }
    return returnNull ? null : ('Unbekannte Option: ' + value);
}
